import type { Token } from 'marked'

export function getChildTokens(token: Token): Token[] {
  return 'tokens' in token && Array.isArray(token.tokens) ? token.tokens : []
}

export function getTokenText(token: Token): string {
  return 'text' in token ? String(token.text) : ''
}
